'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifierForThread = undefined;

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var _isPersistedThread = require('../../thread-histories/operators/isPersistedThread');

var identifierForThread = exports.identifierForThread = function identifierForThread(thread) {
  if ((0, _isPersistedThread.isPersistedThread)(thread)) {
    return (0, _threadGetters.getThreadId)(thread);
  }

  return _stubbedChannel.STUBBED_CHANNEL;
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/operators/identifierForThread.js
// module id = 95
// module chunks = 2 3